import { BASE_API_URL } from "../../../config";
import { authFetch } from "../../authHelper";

export const createCommands = {
  //
  async submitFeedback(feedbackData) {
    const apiPath = `${BASE_API_URL}/api/submitFeedback`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify(feedbackData),
    });
    const result = await response.json();
    return result?.success;
  },

  async createCustomItem(customItem) {
    const apiPath = `${BASE_API_URL}/api/customItems`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify(customItem),
    });
    const result = await response.json().catch(() => null);
    if (response.ok && result?.success) {
      return { success: true, item: result.item };
    }
    return { success: false, error: result?.error || "Failed to add custom item" };
  },
};
